




































import { Component, Prop, Vue } from 'vue-property-decorator'
import CartItem, { ICartItem } from '@/store/models/CartItem'
import { Gender, BasketType, Offer } from '@/data/enums'
import '@/icons/check'

@Component({})
export default class OfferTile extends Vue {
  @Prop() private item!: CartItem
  private get background (): string {
    const age = this.$store.state.matrix.age
    let genderPath = 'male'
    let typePath = 'sun'
    let agePath = '36'

    // GENDER
    if (this.$store.getters['matrix/gender'] === Gender.Female) {
      genderPath = 'female'
    }

    // AGE
    if (age < 36) {
      agePath = '36-'
    } else if ((age >= 36) && (age < 65)) {
      agePath = '36'
    } else {
      agePath = '65'
    }

    // ITEM
    if (this.item.id === Offer.Screen) {
      typePath = 'screen'
    }

    return `profile/cart/${agePath}/${genderPath}_${typePath}.png`
  }

  private get showPrice (): boolean {
    return this.$store.state.data.optician.showPrices
  }

  private get priceTypeText () {
    return this.$store.state.data.optician.priceTypeText
  }
  private onClick () {
    // check if allready contains
    const items = this.$store.state.cart.items

    if (items) {
      if (items.length > 0) {
        const findItem = items.find(
          (cartItem: ICartItem) => cartItem.id === this.item.id
        )
        if (!findItem) {
          items.push(this.item)
        }
      } else if (items.length === 0) {
        items.push(this.item)
      }
    }
  }
}
